/**
 * Shared sonner toast ids. Kept in this standalone leaf module — no imports
 * of its own — so mutation call sites anywhere in the component tree (and
 * any api/*.ts hook file) can pull in an id without creating a circular
 * import back to App.tsx: App.tsx's router transitively imports essentially
 * every page/component in the app, so a component importing the id FROM
 * '@/App' would close a cycle. App.tsx re-exports MUTATION_ERROR_TOAST_ID for
 * back-compat/tests that reach for it off '@/App'; new call sites should
 * import it from here directly.
 */

// Shared with App.tsx's global MutationCache onError backstop. Sonner
// replaces same-id toasts in place, so a mutation's own specific-copy
// toast.error(..., { id: MUTATION_ERROR_TOAST_ID }) overwrites the generic
// backstop toast in place instead of stacking a second one — see App.tsx for
// the full rationale (TanStack Query doesn't expose per-call
// `mutate(vars, { onError })` handlers to the MutationCache callback, only
// hook-level `useMutation({ onError })` ones).
export const MUTATION_ERROR_TOAST_ID = 'mutation-error';
